
@let _metadata = metadata();

  <div class="text-gray-700">
    The selected file contains
    <span class="font-semibold text-emerald-600 text-lg">{{ _metadata.featureCount }}</span>
    features.
  </div>

  @if (_metadata.commonAttributeNames.length > 0) {
    <div class="space-y-2">
      <p class="text-gray-700">
        We found the following common attributes for all features:
      </p>
      <ul class="list-disc list-inside text-gray-600">
        @for (attr of _metadata.commonAttributeNames; track $index) {
          <li>{{ attr }}</li>
        }
      </ul>

      <label class="block text-gray-700 font-medium" for="featureNameAttr">
        Choose which attribute to use as the Feature Name:
      </label>
      <tui-select
  [(ngModel)]="selectedAttribute"
  [tuiTextfieldLabelOutside]="true"
  >

      <input
          placeholder="Select Attribute"
          tuiTextfieldLegacy
      />
      <tui-data-list-wrapper
          *tuiDataList
          [items]="_metadata.commonAttributeNames"
      />
  </tui-select>

  <label class="block text-gray-700 font-medium" for="featureNameAttr">
    Or type a prefix to use for naming each feature:
  </label>

      <tui-input
      [(ngModel)]="typedPrefix"   [tuiTextfieldLabelOutside]="true">

        <input tuiTextfieldLegacy  placeholder="e.g. MyFeature_" type="text" />
      </tui-input>
    </div>
  } @else {
    <div class="space-y-2">
      <p class="text-gray-700">
        No common attributes found for all features.
      </p>
      <label class="block text-gray-700 font-medium" for="featureNameAttr">
        Please type a prefix to use for naming each feature:
      </label>
      <tui-input
      [(ngModel)]="typedPrefix" [tuiTextfieldLabelOutside]="true">

        <input tuiTextfieldLegacy  placeholder="e.g. MyFeature_" type="text" />
      </tui-input>
    </div>
  }

  <div class="p-2 flex justify-end">
    <button
      class="bg-gray-300 hover:bg-gray-400 text-gray-700 py-2 px-4 rounded mr-2"
      (click)="context.$implicit.complete()"
    >
      Cancel
    </button>
    <button
      [disabled]="!canSubmit()"
      class="bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded disabled:bg-blue-300 disabled:cursor-not-allowed"
      (click)="submit()"
    >
      Confirm
    </button>
  </div>


